module.exports = __webpack_public_path__ + "img/niro-19.69666503.png";